import { render, staticRenderFns } from "./addcurriculum.vue?vue&type=template&id=71a8ae1a&scoped=true&"
import script from "./addcurriculum.vue?vue&type=script&lang=js&"
export * from "./addcurriculum.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./addcurriculum.vue?vue&type=style&index=1&id=71a8ae1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a8ae1a",
  null
  
)

export default component.exports